import { TextFieldProps, TextFieldSize } from '@bechtel/gds';
import React, { FC } from 'react';
import { InputWrapperStyled, LabelContainerStyled, TextFieldStyled } from './styled';

interface InputFieldProps {
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  defaultValue?: string;
}

export const InputField: FC<InputFieldProps & TextFieldProps> = ({
  onChange,
  label,
  value,
  defaultValue,
  ...textFieldProps
}) => {
  const initialValue = defaultValue && defaultValue.length > 0 ? defaultValue : '';

  return (
    <InputWrapperStyled checked={initialValue != value}>
      <LabelContainerStyled checked={initialValue != value}>{label}</LabelContainerStyled>
      <TextFieldStyled
        checked={initialValue != value}
        size={TextFieldSize.SMALL}
        value={value}
        onChange={onChange}
        {...textFieldProps}
      />
    </InputWrapperStyled>
  );
};
